import multiPlanCrumbTemplate from './multiPlanCrumb.html';

function multiPlanCrumb() {
  return {
    restrict: 'E',
    scope: {
      plans: '='
    },
    template: multiPlanCrumbTemplate
  };
}

export default function (ngModule) {
  ngModule.directive('multiPlanCrumb', multiPlanCrumb);
}
